export class Tabs
{
    tabs = document.querySelectorAll('[data-s~="Tabs"]');
    navsSelector = ':scope [data-s~="Tabs:nav"] > li';
    panelSelector = ':scope [data-s~="Tabs:panel"] > div[role~="tabpanel"]';
    activeDataS = 'Tabs:nav:active';
    navsDataS = 'Tabs:nav:';
    panelDataS = 'Tabs:panel:';

    disableAllTabs(tabsContainer)
    {
        tabsContainer.querySelectorAll(this.navsSelector).forEach(f => {
            f.dataset.s = f.dataset.s.replace(this.activeDataS, '');
            let button = f.querySelector(':scope button');

            button.parentElement.dataset.d = button.parentElement.dataset.d.replace(/bd-cr=main-1/g, '');
            button.dataset.d = button.dataset.d.replace(/co=we/g, '');
            button.dataset.d += ' co=bk';
            button.dataset.d += ' cu=pr';
            button.dataset.d += ' :hr->bd-cr=1';
            button.setAttribute('aria-selected', 'false');

            button.parentElement.dataset.c = button.parentElement.dataset.c.replace(/bd-cr=bk/g, 'bd-cr=14');
            button.parentElement.dataset.c = button.parentElement.dataset.c.replace(/br-cr=bk/g, 'br-cr=14');
        });
    }

    disableAllPanels(panelContainer)
    {
        panelContainer.querySelectorAll(this.panelSelector).forEach(e => {
            e.dataset.d += " dy=ne";
        });
    }

    enableTab(button)
    {
        button.parentElement.dataset.s = this.activeDataS;

        button.parentElement.dataset.d += ' bd-cr=main-1';
        button.dataset.d += ' co=we';
        button.dataset.d = button.dataset.d.replace(/co=bk/g, '');
        button.dataset.d = button.dataset.d.replace(/cu=pr/g, '');
        button.dataset.d = button.dataset.d.replace(/:hr->bd-cr=1/g, '');
        button.setAttribute('aria-selected', 'true');

        button.parentElement.dataset.c = button.parentElement.dataset.c.replace(/bd-cr=14/g, 'bd-cr=bk');
        button.parentElement.dataset.c = button.parentElement.dataset.c.replace(/br-cr=14/g, 'br-cr=bk');
    }

    enablePanel(container, button)
    {
        let panelDataS = button.dataset.s.replace(this.navsDataS, this.panelDataS);
        let panelToActivate = container.querySelector(':scope [data-s~="' + panelDataS + '"]');
        panelToActivate.dataset.d = panelToActivate.dataset.d.replace(/dy=ne/g, '');
    }

    handle()
    {
        this.tabs.forEach(e => {
            e.querySelectorAll(this.navsSelector + ' > button').forEach(f => {
                f.addEventListener('click', g => {
                    this.disableAllTabs(e);
                    this.disableAllPanels(e);

                    if (g.target.dataset.s === f.dataset.s) {
                        this.enableTab(g.target);
                        this.enablePanel(e, g.target);
                    }
                });
            });
        });
    }

    run()
    {
        document.addEventListener('DOMContentLoaded', () => {
            this.handle();
        });
    }
}